module.exports = __webpack_public_path__ + "images/emoji/soccer.d97fb0d53dc20f060385.png";